import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CalendarEvent } from '../../_types/calendar-event';
import { CalendarEventScope } from '../../_types/calendar-event-scope';
import { CalendarsEventsService } from '../../_services/calendars-events.service';
import { CalendarsEventsScopesService } from '../../_services/calendars-events-scopes.service';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';

@Component({
    selector: 'app-calendar-event-modal.component',
    templateUrl: './calendar-event-modal.component.html',
    standalone: false
})
export class CalendarEventModalComponent {

  public calendarEventFormGroup!: RxFormGroup;

  public selectedEvent: CalendarEvent = new CalendarEvent;

  public scopes: CalendarEventScope[] = [];

  constructor(
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private calendarsEventsService: CalendarsEventsService,
    private calendarsEventsScopesService: CalendarsEventsScopesService,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService
  ) {
    this.calendarEventFormGroup = this.formBuilder.formGroup<CalendarEvent>(this.selectedEvent) as RxFormGroup;
  }


  async ngOnInit(): Promise<void> {

    await this.loadScopes();

    if(this.config.data.event){
      this.selectedEvent = this.config.data.event;
      this.calendarEventFormGroup.patchValue(this.selectedEvent);
    }else{      
      this.selectedEvent.calendarId = this.config.data.calendarId;
      this.selectedEvent.date = moment(this.config.data.date).toDate().toISOString();     
      this.calendarEventFormGroup.patchValue(this.selectedEvent);
    }        
  }

  async loadScopes(){
    let response = await firstValueFrom(this.calendarsEventsScopesService.all({ sort: ['name'] }));
    this.scopes = response.data;
  }

  async save(){
    this.selectedEvent = Object.assign(this.selectedEvent, this.calendarEventFormGroup.value)    
    this.dynamicDialogRef.close(this.selectedEvent);                            
  }

  delete(){    
    this.confirmationService.confirm({
      message: "¿Quieres eliminar el evento del "+moment(this.config.data.date).format("DD/MM/yyyy")+"?",
      header: "Eliminar evento",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {        
          this.calendarsEventsService.delete(this.selectedEvent.id).subscribe({
            next: (data: any) => {
              this.dynamicDialogRef.close();
              this.messageService.add({ closable: true, severity: 'success', detail: "Evento eliminado correctamente" });   
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });            
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });    
  }

  dismiss(){
    //this.activeModal.dismiss();
  }  
}
